<template>
  <button type="button" class="btn" @click="click" :disabled="disabled">
    <img class="icon" :alt="translations.icon" :src="icon" />
  </button>
</template>

<script>
export default {
  name: 'app-button-plus',
  props: {
    disabled: Boolean
  },
  computed: {
    translations() {
      return {
        icon: this.$gettext('Ikona')
      }
    }
  },
  methods: {
    click(e) {
      this.$emit('click', e)
    }
  }
}
</script>
